import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Filter, { FilterModel } from '../../components/Filter/Filter';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import { upsertFilterToKey } from '../../services/filterService';
import { sleep } from '../../services/utils';
import { EstimateStatusObj } from '../../enums/EstimateStatus';
import CustomSelect from '../../components/CustomSelect/CustomSelect';

export class EstimateFilterFields extends FilterModel {
  customer?: number | null;
  statuses: number[];

  constructor(data: any = {}) {
    super(data);
    this.customer = data.customer;
    this.statuses = data.statuses || [];
  }

  public get totalFilters(): number {
    let total = 0;
    if (this.customer) total += 1;
    if (this.statuses && this.statuses.length) total += this.statuses.length;
    if (this.q) total += 1;
    return total;
  }
}

interface EstimatesFilterProps {
  onSubmit: (data: EstimateFilterFields) => void;
  filterFields: EstimateFilterFields;
  pageKey: string;
  withCustomerFilter?: boolean;
}

export default function EstimatesFilter({
  onSubmit,
  filterFields,
  pageKey,
  withCustomerFilter = true,
}: EstimatesFilterProps) {
  const { control, register, handleSubmit, reset } =
    useForm<EstimateFilterFields>({
      mode: 'onBlur',
    });
  const {
    user: { organization },
  } = useAuth();

  const [customers, setCustomers] = useState([]);
  const [customersLoading, setCustomersLoading] = useState(false);

  async function getCustomers() {
    if (organization) {
      setCustomersLoading(true);
      const response = await api.get(
        `organizations/${organization.id}/customers`
      );
      setCustomers(response.data.data);
      await sleep(1000);
      setCustomersLoading(false);
    }
  }

  const clear = () => {
    reset({
      customer: null,
      statuses: [],
      q: null,
      skip: 0,
      take: 25,
    });
    upsertFilterToKey(pageKey, {});
  };

  useEffect(() => {
    reset(filterFields);
  }, [filterFields]);

  useEffect(() => {
    if (withCustomerFilter) {
      getCustomers();
    }
  }, [organization]);

  return (
    <Filter
      isLoading={customersLoading}
      onSubmit={handleSubmit(onSubmit)}
      clear={clear}
      totalApplied={filterFields?.totalFilters || 0}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='mb-3'>
          <input
            {...register('q')}
            className='form-control'
            placeholder='Digite para pesquisar'
            type='text'
          />
        </div>
        {withCustomerFilter && (
          <div className='mb-3'>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className='form-label'>Cliente</label>
            <Controller
              name='customer'
              control={control}
              render={({ field }) => (
                <CustomSelect
                  options={customers.map((customer: any) => ({
                    label: customer.name,
                    value: customer.id,
                  }))}
                  value={field.value ?? ''}
                  onChange={field.onChange}
                  placeholder='Selecione o Cliente'
                />
              )}
            />
          </div>
        )}
        <div className='mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor='inputLabel' className='form-label'>
            Status
          </label>
          {Object.keys(EstimateStatusObj).map((c: any) => (
            <div key={c} className='form-check'>
              <input
                className='form-check-input'
                type='checkbox'
                value={c}
                {...register('statuses')}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className='form-check-label' htmlFor='flexCheckDefault'>
                {EstimateStatusObj[c].title}
              </label>
            </div>
          ))}
        </div>
      </form>
    </Filter>
  );
}
